import { buildAxiosErrorMessage } from '@/utils/buildAxiosErrorMessage'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import { setupAuthInterceptor } from './axios.interceptors'

const API_VERSION = 'v2'

export const axiosGisSector = axios.create({
  timeout: 20000,
  baseURL: `${import.meta.env.VITE_URL_GIS_API}/sector/api/${API_VERSION}`,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Setup auth interceptor
setupAuthInterceptor(axiosGisSector)

// Error handling interceptor
axiosGisSector.interceptors.response.use(undefined, error => {
  const errorMessage = buildAxiosErrorMessage(error, 'Gis Sector Error')
  console.error(errorMessage)
  Sentry.captureException(errorMessage)
})

export const axiosGisMisc = axios.create({
  timeout: 20000,
  baseURL: `${import.meta.env.VITE_URL_GIS_API}/misc/api/${API_VERSION}`,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Setup auth interceptor
setupAuthInterceptor(axiosGisMisc)

// Error handling interceptor
axiosGisMisc.interceptors.response.use(undefined, error => {
  const errorMessage = buildAxiosErrorMessage(error, 'Gis Misc Error')
  console.error(errorMessage)
  Sentry.captureException(errorMessage)
})